var _circle, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgConferenceActive = function SvgConferenceActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#5A5D64"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35664 7.63774C9.57534 7.41934 9.83795 7.24992 10.1271 7.14071C10.4162 7.03149 10.7252 6.98498 11.0337 7.00424C11.3421 7.02351 11.643 7.10812 11.9162 7.25246C12.1895 7.3968 12.429 7.59759 12.6189 7.8415L14.8624 10.7241C15.2736 11.2529 15.4186 11.9417 15.2561 12.5917L14.5724 15.3293C14.5371 15.4711 14.539 15.6197 14.578 15.7605C14.617 15.9013 14.6917 16.0297 14.7949 16.1331L17.8659 19.2045C17.9694 19.308 18.098 19.3828 18.2391 19.4218C18.3801 19.4608 18.5289 19.4626 18.6708 19.427L21.4069 18.7433C21.7276 18.663 22.0624 18.6568 22.3859 18.725C22.7094 18.7933 23.0131 18.9341 23.2742 19.137L26.1565 21.3796C27.1926 22.1859 27.2876 23.7172 26.3602 24.6435L25.0678 25.9361C24.1429 26.8611 22.7605 27.2674 21.4719 26.8136C18.1736 25.653 15.179 23.7645 12.7101 21.2884C10.2344 18.8195 8.34623 15.8249 7.18557 12.5267C6.73311 11.2392 7.13933 9.85534 8.06425 8.9303L9.35664 7.63774Z",
    fill: "#CECFD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13H23V11H19V13ZM23 13H27V11H23V13ZM24 12V8H22V12H24ZM22 8V16H24V8H22Z",
    fill: "#CECFD5"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConferenceActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ConferenceActive.e9a7f1e3.svg";
export { ForwardRef as ReactComponent };